export enum TicketRequestType {
   GeneralTicket = 0,
   SoftwareHardware = 1,
   Email = 2,
   OtherAccount = 3,
   All = 21
}
